import { render, staticRenderFns } from "./changeLogDetail.vue?vue&type=template&id=1b461a29"
import script from "./changeLogDetail.vue?vue&type=script&lang=js"
export * from "./changeLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports